import { Outlet } from 'react-router-dom';
import { Suspense } from 'react';
import { AuthShell } from './AuthShell';
import { PageEnter } from './PageEnter';
import { PageLoader } from '@/components/common/Loaders';

/** Sign in, register, verify, invite, reset: the narrow column of `AuthShell`. */
export function AuthLayout() {
  return (
    <AuthShell>
      <Suspense fallback={<PageLoader />}>
        {/* Keyed on the path inside `PageEnter`: a new page mounts fresh and
            enters; a tab or a filter in the query string does not. */}
        <PageEnter>
          <Outlet />
        </PageEnter>
      </Suspense>
    </AuthShell>
  );
}
